import './layout/Navigation.css';

/**
 * Navigation component for React SPA
 * Matches the Next.js navigation but uses regular <a> tags for external navigation
 */
export default function Navigation() {
  const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
  // If API_BASE_URL is a relative path (e.g. "/api"), fall back to the production API host
  const SWAGGER_BASE = API_BASE_URL.startsWith('http')
    ? API_BASE_URL.replace(/\/api$/, '')
    : 'https://api.testauto.app';
  const SWAGGER_URL = SWAGGER_BASE + '/swagger-ui/index.html';

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <a href="/">
            <h1>TestAuto.app</h1>
            <span className="tagline">Test Automation Training Platform</span>
          </a>
        </div>
        
        <ul className="nav-links">
          <li>
            <a href="/">Home</a>
          </li>
          <li>
            <a href="/task-manager">Task Manager (SSR)</a>
          </li>
          <li>
            <a href="/task-manager-spa" className="active">
              Task Manager (SPA) ⚡
            </a>
          </li>
          <li>
            <a href="/docs">Docs</a>
          </li>
          <li>
            <a 
              href={SWAGGER_URL}
              target="_blank" 
              rel="noopener noreferrer"
            >
              API Docs
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
